// Entry point for the build script in your package.json
import '@hotwired/turbo-rails';
import './controllers';
import 'trix';
import '@rails/actiontext';

// Some Android browsers (Chrome, Samsung Internet) only open the native date/time
// picker via its icon; tapping the field itself does nothing (#526).
// Touch only, so desktop users can keep typing the date segments.
document.addEventListener('click', (event) => {
  if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;

  const input = event.target.closest?.(
    'input[type="date"], input[type="time"]',
  );
  if (!input || input.disabled || input.readOnly) return;

  try {
    input.showPicker();
  } catch {
    // showPicker unsupported or picker already open: keep native behaviour
  }
});

// Add custom actions for TurboStream
import { StreamActions } from '@hotwired/turbo';

StreamActions.redirect = function () {
  const url = this.getAttribute('url');
  window.Turbo.visit(url);
};
